<div class="container">
  <mic-breadcrumb id="casing-repair-create-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/productData/casing-CreditRepair"
      label="{{ translationService.translate('CasingCreditRepairText') }}"
    ></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('createCasingCreditRepairText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h3 class="m-0 mt-3" id="casing-repair-heading">
    {{ translationService.translate('createCasingCreditRepairText') || 'Create Casing Credit Repair' }}
  </h3>

  <mat-card class="mt-3">
    <form [formGroup]="createForm" style="padding: 20px">
      <div style="display: flex; align-items: center">
        <div style="flex: 1; display: flex; align-items: flex-start">
          <div style="align-items: normal; flex: 1; max-width: 300px">
            <mat-form-field class="w-full" id="codeField">
              <mat-label class="custom-label-error">{{ translationService.translate('codeText') }}</mat-label>
              <input subscriptSizing="dynamic" id="code-input" matInput type="text" formControlName="code" required maxlength="10" />
              @if (createForm.get('code')?.hasError('required')) {
              <mat-error>
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
              }
            </mat-form-field>
          </div>

          <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%; max-width: 300px">
            <mat-form-field class="w-full" id="descriptionField">
              <mat-label class="custom-label-error">{{ translationService.translate('descriptionText') }}</mat-label>
              <input
                subscriptSizing="dynamic"
                id="description-input"
                matInput
                type="text"
                formControlName="description"
                required
                maxlength="50"
              />
              @if (createForm.get('description')?.hasError('required')) {
              <mat-error>
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <!-- Buttons moved to the right side -->
        <div class="flex" style="margin-left: 20px; align-items: center">
          <!-- Cancel Button -->
          <button id="cancel-button" mat-flat-button (click)="navigateBack()">
            <mat-icon>cancel</mat-icon> {{ translationService.translate('cancelText') }}
          </button>

          <!-- Save Button -->
          <button id="save-changes" type="button" mat-flat-button color="primary" (click)="saveChanges()" [disabled]="createForm.invalid">
            <mat-icon>save</mat-icon> {{ translationService.translate('saveLinkText') }}
          </button>
        </div>
      </div>
    </form>
  </mat-card>

  <!-- Repairs Table Section -->

  <div id="repairs-table" class="cam-table table-container">
    <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>
      <ng-container *micTableColumnSelector>
        <button mat-flat-button><mat-icon>view_column</mat-icon> {{ translationService.translate('columnsButtonText') }}</button>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'amount'">
        <input
          subscriptSizing="dynamic"
          id="AmountInput"
          matInput
          type="text"
          min="0"
          pattern="^\\d{0,3}(\\.\\d{0,2})?$"
          maxlength="6"
          [formControl]="getControl(item)"
          (keydown)="handleKeydown($event)"
          (input)="restrictTwoDecimalPlaces($event, item)"
          (blur)="onAmountBlur($event, item)"
          placeholder="0.00"
        />
      </ng-container>
    </mic-table>
  </div>

  <!-- Loading Overlay -->
  @if (isLoading) {
  <div class="loading-overlay">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
  }

  <!-- Unsaved Changes Modal -->
  <ng-template #unsavedConfirmation>{{ translationService.translate('unSaveChangesText') }}</ng-template>
  <mic-modal class="modalC" #unsavedChangesModal></mic-modal>
</div>
